import { render, staticRenderFns } from "./ResponsiblePerson.vue?vue&type=template&id=f3610906&scoped=true"
import script from "./ResponsiblePerson.vue?vue&type=script&lang=js"
export * from "./ResponsiblePerson.vue?vue&type=script&lang=js"
import style0 from "./ResponsiblePerson.vue?vue&type=style&index=0&id=f3610906&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3610906",
  null
  
)

export default component.exports